<template>
    <q-drawer
        elevated
        v-model="drawer"
        :width="200"
        :breakpoint="500"
        behavior="mobile"
        @hide="hide()"
        class="bg-secondary text-white"
      >
        <q-scroll-area class="fit" style="margin-top: 80px">
          <q-list>
            
            <q-item clickable to="/" v-ripple  v-if="!merchant" class="q-my-sm"
                @click="merchant = false">
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/my-code-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    My Code
                </q-item-section>
            </q-item>

            <q-item clickable to="/merchant/scan" v-ripple v-if="merchant" class="q-my-sm"
                @click="merchant = true">
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/scan-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    Scan
                </q-item-section>
            </q-item>

            <q-item clickable to="/full-history/merchant" v-ripple v-if="merchant">
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/history-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    Business History
                </q-item-section>
            </q-item>

            <q-item clickable to="/full-history" v-ripple v-else>
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/history-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    History
                </q-item-section>
            </q-item>

            <q-expansion-item
                v-if="merchant && hasPlace"
                expand-separator
                size="md"
                icon="img:/assets/icons/slice2-dig.svg"
                label="Business"
                class="text-left text-subtitle1"
            >
                <q-list class="bg-primary text-white">
                    <q-item active-class="text-black" clickable v-close-popup @click="selectPlace">
                        <q-item-section avatar>
                            <q-icon size="md" color="white" name="edit" />
                        </q-item-section>
                        <q-item-label class="flex flex-center">Edit</q-item-label>
                    </q-item>
                    <q-item active-class="text-black" clickable v-close-popup to="/merchant/plan">
                        <q-item-section avatar>
                            <q-icon size="md" color="white" name="list" />
                        </q-item-section>
                        <q-item-label>Plan</q-item-label>
                    </q-item>
                    <q-item active-class="text-black" clickable v-close-popup to="/merchant/billing-history">
                        <q-item-section avatar>
                            <q-icon color="white" name="receipt" />
                        </q-item-section>
                        <q-item-label>Subscriptions</q-item-label>
                    </q-item>
                </q-list>
            </q-expansion-item>

            <q-expansion-item
                v-if="!merchant"
                expand-separator
                size="md" 
                icon="img:/assets/icons/slice1-dig.svg"
                label="Profile"
                class="text-left text-subtitle1"
            >
                <q-list class="bg-primary text-white">
                    <q-item active-class="text-black" v-if="!logged" clickable :to="{name: 'User_SignIn'}">
                        <q-item-section avatar>
                            <q-avatar size="md" icon="lock_open" text-color="white" />
                        </q-item-section>
                        <q-item-section>Sign In</q-item-section>
                    </q-item>

                    <q-item active-class="text-black" v-if="!logged" clickable :to="{name:'User_SignUp'}">
                        <q-item-section avatar>
                            <q-avatar size="md" icon="person_add_alt" text-color="white" />
                        </q-item-section>
                        <q-item-section>Sign Up</q-item-section>
                    </q-item>


                    <q-item active-class="text-black" clickable to="/user/edit" v-if="logged">
                        <q-item-section avatar>
                            <q-icon size="md" color="white" name="edit" />
                        </q-item-section>
                        <q-item-label class="flex flex-center">Edit</q-item-label>
                    </q-item>
                </q-list>
            </q-expansion-item>

            <q-item clickable to="/" v-ripple v-if="merchant"
                @click="merchant = false">
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/switch-personal-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    Switch to Personal
                </q-item-section>
            </q-item>

            <q-item clickable to="/merchant/scan" v-ripple 
                @click="merchant = true" v-else>
                <q-item-section avatar>
                    <q-icon size="md" name="img:/assets/icons/switch-business-icon-dig.svg" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    Switch to Business
                </q-item-section>
            </q-item>

            <q-item clickable  class="text-white" v-ripple @click="handleLogout" v-if="logged">
                <q-item-section avatar>
                    <q-icon size="md" name="logout" />
                </q-item-section>
                <q-item-section class="text-left text-subtitle1">
                    Logout
                </q-item-section>
            </q-item>
          </q-list>
        </q-scroll-area>

        <div class="q-my-sm absolute-top text-center">
            <q-img src="/assets/icon-app/apple-icon-144x144.png"  width="50px" />
        </div>
    </q-drawer>
</template>
<script>
import router from "@/router";
import { computed, ref } from '@vue/reactivity';
import { inject, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useQuasar } from 'quasar';

export default {
  props: ['drawer'],
  name: 'bottom-bar',
  setup(props, context) {
    const $q = useQuasar()
    const store = useStore()
    const logged = computed(() => store.getters.isAuthenticated && !store.getters.isAnonymous)
    const merchant = ref(false)
    const upgrade = ref(true)
    const tab = ref(null)
    const axios = inject('axios')

    const hasPlace = computed(() => store.getters.hasPlace)

    function handleLogout() {
      axios.get(`${process.env.VUE_APP_URL}/logout`)
        .then(async resp => {    
          store.commit('setUser', null)
          store.commit('setClearHistory')
          store.commit('clearPlace')
          location.reload()
        })
        .catch(err => {
          $q.notify({
            message: 'An error has ocurred!',
            caption: err.message,
            color: 'negative'
          })
        })
    }

    const selectPlace = () => {
        let place = store.getters.statePlace.id
        router.push(`/merchant/addplace/${place}`)
    }

    const hide = () => {
        context.emit('hide')
    }

    watch(() => router.currentRoute.value, () => {
        if (router.currentRoute.value.fullPath.includes('merchant')) merchant.value = true
        else merchant.value = false

    },{immediate:true});
    
    return {logged, handleLogout, merchant, selectPlace, upgrade, tab, hide, hasPlace}
  }
}
</script>